import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import { mediumUp } from 'constants/mediaQueries';
import Theme from 'styles/theme';
import RichTextProcessor from 'utils/RichTextProcessor';

const RichText = ({ content, options, className }) => {
  const classes = classnames('RichText', className);
  const processedContent = new RichTextProcessor(content, options).getReactComponents();

  return (
    <div className={classes}>
      {processedContent}
      <style jsx global>
        {`
          .RichText p.Paragraph,
          .RichText ul.UnorderedList,
          .RichText h1.typography--primary-heading,
          .RichText h2.typography--secondary-heading,
          .RichText h3.typography--tertiary-heading,
          .RichText h4.typography--quaternary-heading,
          .RichText h5.typography--quinary-heading {
            margin-bottom: ${Theme.get('spacing') * 5}px;
          }

          .RichText .UnorderedList p.Paragraph {
            margin-bottom: 0;
          }

          .RichText > h1.typography--primary-heading:first-child,
          .RichText > h2.typography--secondary-heading:first-child,
          .RichText > h3.typography--tertiary-heading:first-child,
          .RichText > h4.typography--quaternary-heading:first-child,
          .RichText > h5.typography--quinary-heading:first-child {
            padding-top: 0;
          }

          .RichText > h1.typography--primary-heading,
          .RichText > h2.typography--secondary-heading,
          .RichText > h3.typography--tertiary-heading,
          .RichText > h4.typography--quaternary-heading,
          .RichText > h5.typography--quinary-heading {
            padding-top: ${Theme.get('spacing') * 2}px;
          }

          @media ${mediumUp} {
            .RichText > :first-child {
              padding-top: 0;
            }

            .RichText > h1.typography--primary-heading,
            .RichText > h2.typography--secondary-heading,
            .RichText > h3.typography--tertiary-heading,
            .RichText > h4.typography--quaternary-heading,
            .RichText > h5.typography--quinary-heading {
              padding-top: ${Theme.get('spacing') * 5}px;
            }
          }
        `}
      </style>
    </div>
  );
};

RichText.propTypes = {
  content: PropTypes.shape({}).isRequired,
  options: PropTypes.shape({}),
  className: PropTypes.string,
};

RichText.defaultProps = {
  options: {},
  className: '',
};

export default RichText;
